import React from "react";
import "../../CSS/components.css";
import { useState, useContext } from "react";
import { Button, TextInput } from "../indexComponents";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../App";

function CreateAccountForm() {
  const { setIsAuthenticated, redirectLink } = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState("");

  const [formData, setFormData] = useState({
    username: "",
    fullName: "",
    password: "",
    email: "",
  });

  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!/^[a-zA-Z0-9]{4,}$/.test(formData.username)) {
      setErrorMessage("Le nom d'utilisateur doit contenir au moins 3 lettres.");
      setTimeout(() => {
        setErrorMessage("");
      }, 2500);
      return; // Arrêter le traitement si le nom d'utilisateur est invalide
    }

    if (formData.password.length < 6) {
      setErrorMessage("Le mot de passe doit contenir au moins 6 caractères.");
      setTimeout(() => {
        setErrorMessage("");
      }, 2500);
      return;
    }
    if (!/[A-Z]/.test(formData.password)) {
      setErrorMessage("Le mot de passe doit inclure au moins une majuscule.");
      setTimeout(() => {
        setErrorMessage("");
      }, 2500);
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: formData.username,
          fullName: formData.fullName,
          password: formData.password,
          email: formData.email,
        }),
      });

      if (!response.ok) {
        if (response.status === 409) {
          setErrorMessage("Ce nom d'utilisateur est déjà utilisé.");
          setTimeout(() => {
            setErrorMessage("");
          }, 2500);
          return;
        } else {
          if (response.status === 410) {
            setErrorMessage("Un compte existe déjà avec ce courriel.");
            setTimeout(() => {
              setErrorMessage("");
            }, 2500);
            return;
          } else {
            throw new Error("Failed to create user : email is invalid");
          }
        }
      }

      // Log in the user after successful signup
      const loginResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: formData.username,
            password: formData.password,
          }),
        }
      );

      const loginData = await loginResponse.json();

      // Store the token and set the authentication status
      if (loginData.token) {
        localStorage.setItem("token", loginData.token);
        setIsAuthenticated(true); // Set isAuthenticated to true when the login is successful
        navigate(redirectLink);
      } else {
        throw new Error("Login failed");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="SignupForm">
      <form>
        <h1>Créer un compte</h1>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        <TextInput
          labelText="Nom d'utilisateur"
          name="username"
          type="text"
          placeholder=""
          value={formData.username}
          onChange={handleChange}
        />
        <TextInput
          labelText="Nom Complet"
          name="fullName"
          type="text"
          placeholder=""
          value={formData.fullName}
          onChange={handleChange}
        />
        <TextInput
          labelText="Mot de passe"
          name="password"
          type="password"
          placeholder=""
          value={formData.password}
          onChange={handleChange}
        />
        <TextInput
          labelText="Email"
          name="email"
          type="email"
          placeholder=""
          value={formData.email}
          onChange={handleChange}
        />
        {/* <Button route="/login" divClass="btn-login" type="submit" text="S'inscrire"></Button> */}
        <button type="submit" onClick={handleSubmit}>
          Créer
        </button>
      </form>
      <div>
        <h2>Déja un compte ?</h2>
        <Button
          route="/login"
          divClass="btn-login"
          type=""
          text="Se connecter"
        ></Button>
      </div>
    </div>
  );
}

export default CreateAccountForm;
